import {
  DashboardMetricCard,
  DashboardMetricGrid,
  TALENTCO_CANDIDATE_KPI_GRID,
  DashboardStatsSkeleton,
  Card,
  countCandidateHomeMetrics,
} from '@yeshuman/sdk'
import { useMemo } from 'react'
import { Bookmark, Briefcase, Calendar, Search, Star } from 'lucide-react'

import { CandidateDashboardFeaturedJobsSection } from './candidate-dashboard-featured-jobs'
import { useMyApplications } from '../../hooks/use-my-applications'
import { useSavedOpportunities } from '../../hooks/use-saved-opportunities'

export function CandidateHomeSections() {
  const {
    applications,
    isLoading: isLoadingApplications,
    error: applicationsError,
  } = useMyApplications()
  const {
    savedOpportunities,
    savedCount,
    isLoading: isLoadingSaved,
    error: savedError,
  } = useSavedOpportunities()

  const metrics = useMemo(
    () => countCandidateHomeMetrics(savedOpportunities, applications, savedCount),
    [applications, savedCount, savedOpportunities],
  )
  const isLoadingMetrics = isLoadingApplications || isLoadingSaved
  const metricsError = applicationsError || (savedError ? 'Unable to load saved jobs' : null)

  return (
    <>
      <Card className="bg-transparent">
        {isLoadingMetrics ? (
          <DashboardStatsSkeleton
            count={5}
            variant="plain"
            layoutClassName={TALENTCO_CANDIDATE_KPI_GRID}
          />
        ) : metricsError ? (
          <div className="text-center py-4 text-muted-foreground">
            <p>Unable to load dashboard stats</p>
          </div>
        ) : (
          <DashboardMetricGrid variant="plain" layoutClassName={TALENTCO_CANDIDATE_KPI_GRID}>
            <DashboardMetricCard title="Saved" value={metrics.saved} icon={Bookmark} />
            <DashboardMetricCard title="Applications" value={metrics.applications} icon={Briefcase} />
            <DashboardMetricCard title="In review" value={metrics.inReview} icon={Search} />
            <DashboardMetricCard title="Shortlisted" value={metrics.shortlisted} icon={Star} />
            <DashboardMetricCard title="Interviews" value={metrics.interviews} icon={Calendar} />
          </DashboardMetricGrid>
        )}
      </Card>

      <CandidateDashboardFeaturedJobsSection />
    </>
  )
}
